import type {
  FormData,
  GeneratedContent,
  UserData,
  EvaluationType_Option,
} from "../types";
import { normalizeN8nResponse } from "../pdf/PDFRenderer";
import { PreviewHeader } from "../preview/PreviewHeader";
import { EvaluationHeader } from "../preview/EvaluationHeader";
import { InstructionsSection } from "../preview/InstructionsSection";
import { ObjectiveQuestions } from "../preview/ObjectiveQuestions";
import { EssayQuestions } from "../preview/EssayQuestions";
import { FooterSection } from "../preview/FooterSection";

interface PreviewStepProps {
  formData: FormData;
  generatedContent: GeneratedContent;
  userData: UserData | null;
  evaluationTypes: EvaluationType_Option[];
}

export const PreviewStep: React.FC<PreviewStepProps> = ({
  formData,
  generatedContent,
  userData,
  evaluationTypes,
}) => {
  // Normalize N8N response to expected format
  const normalized = normalizeN8nResponse(generatedContent);

  return (
    <div className="print-container bg-white rounded-lg shadow-sm max-w-4xl mx-auto">
      <PreviewHeader
        formData={formData}
        userData={userData}
        evaluationTypes={evaluationTypes}
      />

      <EvaluationHeader formData={formData} evaluationTypes={evaluationTypes} />

      <InstructionsSection content={normalized} />

      <ObjectiveQuestions
        content={normalized}
        evaluationTypes={evaluationTypes}
      />

      <EssayQuestions content={normalized} />

      <FooterSection content={normalized} />
    </div>
  );
};
